import { CampaignMessageDto } from '../interfaces/dto/campaign-message.dto';
import { ConversationDto } from '../interfaces/dto/conversation.dto';

export function isConversationDto(item: ConversationDto | CampaignMessageDto): item is ConversationDto {
  return (item as ConversationDto).messages !== undefined;
}
